/**
 * Reddit Pixel — thin wrapper around window.rdt.
 * The base snippet (init + PageVisit) lives in the HTML shells
 * (public/index.html, public/landing/home/index.html); this module only
 * fires standard events from React code and tracks the ad click id.
 */

const CLICK_ID_KEY = 'bh_rdt_click_id';

/** Reads the Reddit click id captured from ?rdt_cid=... on landing, if any. */
export function getStoredRedditClickId() {
  try {
    return localStorage.getItem(CLICK_ID_KEY) || null;
  } catch {
    return null;
  }
}

/** Fires a Reddit Pixel standard event. No-ops if the pixel didn't load (blocked, consent denied, SSR). */
export function rdtTrack(eventName, props) {
  try {
    if (typeof window !== 'undefined' && typeof window.rdt === 'function') {
      window.rdt('track', eventName, props);
    }
  } catch {
    // Never let a tracking failure affect the app.
  }
}
